




























































































































































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";

import Paginate from "@/components/Paginate.vue";
import Multiselect from "vue-multiselect";
const InvoicesIncoming = namespace("InvoicesModule");

import NotificationMixin from "@/mixins/notification.mixin";
import * as _ from "lodash";

@Component({
  name: "InvoiceIncoming",
  mixins: [NotificationMixin],
  components: {
    DatePicker,
    Paginate,
    Multiselect,
  },
  filters: {
    formatDate: function (value: any) {
      if (!value) {
        return "";
      }
      const cDate = new Date(value);

      return (
        cDate.getFullYear() +
        "-" +
        String(cDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(cDate.getDate()).padStart(2, "0")
      );
    },
  },
})
export default class InvoiceIncoming extends Mixins(NotificationMixin) {
  private currency = "EUR";
  private isLoading = false;
  private urlRetrieve = "invoices/incoming/search";
  private urlTotalAmount = "invoices/incoming/total-amount";
  private status = false;
  private CreditorList = [];
  private InvoiceStatus = null;
  private totalInfo = {
    TotalPaid: 0,
    TotalUnpaid: 0,
    TotalDisputed: 0,
  };
  private paidStatusOptions = [
    { value: null, text: "Status" },
    { value: 1, text: "Paid" },
    { value: 2, text: "UnPaid" },
    { value: 3, text: "Disputed" },
  ];
  private InvoiceStatusOptions = [
    { value: 1, text: "Paid" },
    { value: 2, text: "UnPaid" },
    { value: 3, text: "Disputed" },
  ];
  private invoiceTypeOptions = [
    { value: null, text: "Invoice Type" },
    { value: "D", text: "Debit" },
    { value: "C", text: "Credit" },
  ];
  private invoiceTypeValue = {
    D: "Debit",
    C: "Credit",
  };
  private IncomingInvoices = [];
  private SortDate: any = null;
  private SortAmount: any = null;
  private filter = {
    ReceivedDateFrom: new Date(),
    ReceivedDateTo: new Date(),
    PaymentDateFrom: new Date(),
    PaymentDateTo: new Date(),
    CreditorInvoiceNr: null,
    CreditorName: null,
    Amount: null,
    InvoiceType: null,
    PaidStatus: null,
    NoteCommunication: null,
    InvoiceNrSFS: null,
    InvoiceNr: null,
    BlockCode: null,
    Sort: "",
    Index: "",
  };
  private paginate = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };
  private newCommunication = null;

  constructor() {
    super();
  }

  created() {
    this.searchData();
    this.calTotalAmount();
  }

  pageChange(params: any) {
    this.getItemPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
      (response) => {
        this.IncomingInvoices = response.invoiceList;
        if (response.Paginate) {
          this.paginate = response.Paginate;
          this.CreditorList = this.creditorOptionList;
        }
      },
      (error) => {
        this.onShowFlashMessage(error, "Error", "danger");
      }
    );
  }

  public searchData(): void {
    this.isLoading = true;
    this.retrieveInvoices(this.filterQuery()).then(
      (response) => {
        this.paginate = response.Paginate;
        this.IncomingInvoices = response.invoiceList;
        this.CreditorList = this.creditorOptionList;
        this.isLoading = false;
        this.calTotalAmount();
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {};
    // We will search from Datefrom at default
    //@TODO: if the sort order is descending and sort type is invoicedate, we will start from dateto
    const ReceivedDateFrom: any =
      filter.ReceivedDateFrom == null ? new Date() : filter.ReceivedDateFrom;
    const searchYear = ReceivedDateFrom.getFullYear();
    filterData.PartitionKey = searchYear;

    // Index using and sort
    if (filter.Index) {
      filterData.Index = filter.Index;
    }
    if (filter.Sort) {
      filterData.Sort = filter.Sort;
    }
    filterData.Filter = this.makeFilter();
    return { url: this.urlRetrieve, filterData: filterData };
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];
    const invoiceNr: any = filter.InvoiceNr;
    const creditor: any = filter.CreditorName;
    Filter.push({
      Key: "CreateAt",
      Operator: "greatThanEqual",
      Value: this.getDateString(filter.ReceivedDateFrom),
    });
    Filter.push({
      Key: "CreateAt",
      Operator: "lessThanEqual",
      Value: this.getDateString(filter.ReceivedDateTo),
    });
    if (filter.PaymentDateFrom) {
      Filter.push({
        Key: "DateOfPayment",
        Operator: "greatThanEqual",
        Value: this.getDateString(filter.PaymentDateFrom),
      });
    }
    if (filter.PaymentDateTo) {
      Filter.push({
        Key: "DateOfPayment",
        Operator: "lessThanEqual",
        Value: this.getDateString(filter.PaymentDateTo),
      });
    }
    if (filter.CreditorName) {
      Filter.push({
        Key: "CreditorName",
        Value: filter.CreditorName,
      });
    }
    if (filter.CreditorInvoiceNr) {
      Filter.push({
        Key: "RealInvoiceNr",
        Operator: "contains",
        Value: filter.CreditorInvoiceNr,
      });
    }
    if (filter.BlockCode) {
      Filter.push({
        Key: "BlockCode",
        Operator: "contains",
        Value: filter.BlockCode,
      });
    }
    if (filter.InvoiceNrSFS) {
      Filter.push({
        Key: "InvoiceNrSFS",
        Value: filter.InvoiceNrSFS,
      });
    }
    if (filter.InvoiceType) {
      Filter.push({
        Key: "InvoiceType",
        Operator: "contains",
        Value: filter.InvoiceType,
      });
    }
    if (filter.PaidStatus) {
      Filter.push({
        Key: "Status",
        Value: filter.PaidStatus,
      });
    }
    return Filter;
  }

  public sortDate(): void {
    if (this.SortDate == null) {
      this.SortDate = "desc";
    } else {
      this.SortDate = this.SortDate == "desc" ? "asc" : "desc";
    }
    this.filter.Sort = this.SortDate;
    this.filter.Index = "InvoiceDateSort";
    this.SortAmount = null;
    this.searchData();
  }

  public sortAmount(): void {
    if (this.SortAmount == null) {
      this.SortAmount = "desc";
    } else {
      this.SortAmount = this.SortAmount == "desc" ? "asc" : "desc";
    }
    this.SortDate = null;
    this.filter.Sort = this.SortAmount;
    this.filter.Index = "AMountTotalInclVAT";
    this.searchData();
  }

  public updateStatus(
    InvoiceNr: number,
    InvoiceFinanceYear: number,
    event: any
  ): void {
    this.updateInvoice({
      url: "invoices/" + InvoiceNr + "/incoming",
      data: {
        FinanceYear: InvoiceFinanceYear,
        Status: event,
      },
    }).then(
      (response) => {
        if (response.Error) {
          this.onShowFlashMessage(response.Error.message, "Error", "danger");
        } else {
          this.onShowFlashMessage("Update Status Successfully!");
          this.calTotalAmount();
        }
      },
      (error) => {
        this.onShowFlashMessage(error, "Error", "danger");
      }
    );
  }

  public calTotalAmount(): void {
    //get total amount for filter
    //get total amount for all
    this.getTotalAmount({
      url: this.urlTotalAmount,
      data: {
        DateFrom: this.getDateString(this.filter.ReceivedDateFrom),
        DateTo: this.getDateString(this.filter.ReceivedDateTo),
        Filter: this.makeFilter(),
      },
    }).then((response) => {
      this.totalInfo.TotalPaid = response.data[0].TotalPaid;
      this.totalInfo.TotalUnpaid = response.data[0].TotalUnpaid;
      this.totalInfo.TotalDisputed = response.data[0].TotalDisputed;
    });
  }

  getDateString(value: any): string {
    value = value == null ? new Date() : value;
    return (
      value.getFullYear() +
      "-" +
      String(value.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(value.getDate()).padStart(2, "0")
    );
  }

  addCommunication(invoiceFinanceYear: number, invoiceNr: number): void {
    this.updateInvoice({
      url: "invoices/" + invoiceNr + "/incoming",
      data: {
        FinanceYear: invoiceFinanceYear,
        NoteCommunication: this.newCommunication,
        Type: "add",
      },
    }).then(
      (response) => {
        if (_.first(response.data)) {
          const indexInvoice = _.findIndex(this.invoiceList, function (o) {
            return o.InvoiceNr == invoiceNr;
          });
          this.invoiceList[indexInvoice].NoteCommunication =
            response.data[0].NoteCommunication;
          this.newCommunication = null;
        }
      },
      (error) => {
        this.onShowFlashMessage(error, "Error", "danger");
      }
    );
  }

  removeCommunication(
    invoiceFinanceYear: number,
    invoiceNr: number,
    note: any
  ): void {
    const indexInvoice = _.findIndex(this.invoiceList, function (o) {
      return o.InvoiceNr == invoiceNr;
    });
    const arrayRemove = _.reject(
      this.invoiceList[indexInvoice].NoteCommunication,
      note
    );
    this.updateInvoice({
      url: "invoices/" + invoiceNr + "/incoming",
      data: {
        FinanceYear: invoiceFinanceYear,
        NoteCommunication: arrayRemove,
        Type: "remove",
      },
    }).then(
      (response) => {
        if (_.first(response.data)) {
          this.invoiceList[indexInvoice].NoteCommunication =
            response.data[0].NoteCommunication;
        }
      },
      (error) => {
        this.onShowFlashMessage(error, "Error", "danger");
      }
    );
  }

  notBeforeDateFrom(date: Date) {
    const dateFrom = new Date(this.filter.ReceivedDateFrom);
    dateFrom.setHours(0, 0, 0, 0);
    return date.getTime() < dateFrom.getTime();
  }

  notAfterDateTo(date: Date) {
    const dateTo = new Date(this.filter.ReceivedDateTo);
    dateTo.setHours(0, 0, 0, 0);
    return date.getTime() > dateTo.getTime();
  }

  notBeforePaymentDateFrom(date: Date) {
    const dateFrom = new Date(this.filter.PaymentDateFrom);
    dateFrom.setHours(0, 0, 0, 0);
    return date.getTime() < dateFrom.getTime();
  }

  notAfterPaymentDateTo(date: Date) {
    const dateTo = new Date(this.filter.PaymentDateTo);
    dateTo.setHours(0, 0, 0, 0);
    return date.getTime() > dateTo.getTime();
  }

  @InvoicesIncoming.State
  public invoiceList!: Array<any>;

  @InvoicesIncoming.State
  public lastKey!: any;

  @InvoicesIncoming.State
  public creditorOptionList!: any;

  @InvoicesIncoming.Action
  public retrieveInvoices!: (params: any) => Promise<any>;

  @InvoicesIncoming.Action
  public getItemPerPage!: (params: any) => Promise<any>;

  @InvoicesIncoming.Action
  public updateInvoice!: (params: any) => Promise<any>;

  @InvoicesIncoming.Action
  public getTotalAmount!: (params: any) => Promise<any>;
}
